export default __webpack_public_path__ + "static/media/back_hover.bf12b911.svg";